module.exports = __webpack_public_path__ + "img/android-icon.60184507.svg";